import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { CheckboxFieldWUT } from '../../../ui/checkbox-field';
import { getEcomSubscriptionLabel } from '../get-label';
export const EcomSubscriptionCheckboxWUT = props => {
  const fieldType = FIELD_TYPES.ECOM_SUBSCRIPTION;
  const {
    t
  } = useTranslation();
  const label = useMemo(() => getEcomSubscriptionLabel(t), [t]);
  return /*#__PURE__*/React.createElement(CheckboxFieldWUT, _extends({}, props, {
    label: label,
    fieldType: fieldType
  }));
};
//# sourceMappingURL=ecom-subscription-checkbox-wut.js.map